import React from "react";

// Warm brand-palette vector illustrations — no photography.
const C = { char: "#3E3E3E", orange: "#F56B1F", sand: "#D7C6A9", off: "#F5F2EB", sub: "#EEE9DE", line: "#E3DAC8" };

// Hero: a warm living room scene, stylised flat vectors.
export function LivingRoomArt({ className = "" }) {
  return (
    <svg viewBox="0 0 520 420" className={className} role="img" aria-label="Illustration of a designed living room" fill="none">
      <rect x="8" y="8" width="504" height="404" rx="24" fill={C.off} />
      <rect x="8" y="8" width="504" height="404" rx="24" stroke={C.line} strokeWidth="2" />
      {/* back wall panels */}
      <rect x="40" y="46" width="200" height="150" rx="8" fill="#fff" stroke={C.line} strokeWidth="2" />
      <line x1="140" y1="46" x2="140" y2="196" stroke={C.line} strokeWidth="2" />
      {/* framed art */}
      <rect x="300" y="60" width="90" height="70" rx="6" fill={C.sub} stroke={C.line} strokeWidth="2" />
      <path d="M312 116 L336 88 L352 104 L366 84 L380 116 Z" fill={C.sand} />
      <circle cx="322" cy="80" r="6" fill={C.orange} />
      {/* pendant lamp */}
      <line x1="440" y1="46" x2="440" y2="90" stroke={C.char} strokeWidth="2" />
      <path d="M424 90 h32 l-8 22 h-16 Z" fill={C.orange} />
      {/* shelf */}
      <rect x="418" y="150" width="70" height="10" rx="3" fill={C.char} />
      <rect x="426" y="128" width="10" height="22" rx="2" fill={C.sand} />
      <rect x="442" y="120" width="10" height="30" rx="2" fill={C.orange} />
      <circle cx="470" cy="138" r="9" fill={C.sub} stroke={C.char} strokeWidth="2" />
      {/* floor line */}
      <line x1="40" y1="300" x2="480" y2="300" stroke={C.line} strokeWidth="2" />
      {/* sofa */}
      <rect x="70" y="236" width="220" height="64" rx="18" fill={C.char} />
      <rect x="78" y="214" width="204" height="44" rx="16" fill="#4a4a4a" />
      <rect x="96" y="222" width="56" height="34" rx="10" fill={C.orange} />
      <rect x="164" y="222" width="56" height="34" rx="10" fill={C.sand} />
      <rect x="82" y="298" width="14" height="26" rx="4" fill="#2a2a2a" />
      <rect x="266" y="298" width="14" height="26" rx="4" fill="#2a2a2a" />
      {/* coffee table */}
      <rect x="150" y="330" width="120" height="14" rx="6" fill={C.sand} />
      <rect x="160" y="344" width="8" height="20" rx="3" fill={C.char} />
      <rect x="252" y="344" width="8" height="20" rx="3" fill={C.char} />
      {/* plant */}
      <rect x="410" y="300" width="34" height="40" rx="6" fill={C.sand} />
      <path d="M427 300 C 410 270 404 250 420 236 C 424 258 428 276 427 300 Z" fill={C.char} />
      <path d="M427 300 C 444 274 452 254 438 240 C 432 262 430 280 427 300 Z" fill="#4a4a4a" />
      {/* floor lamp */}
      <line x1="360" y1="300" x2="360" y2="210" stroke={C.char} strokeWidth="3" />
      <path d="M346 210 h28 l-6 -20 h-16 Z" fill={C.orange} />
      <rect x="348" y="300" width="24" height="6" rx="3" fill={C.char} />
      {/* rug */}
      <ellipse cx="205" cy="360" rx="150" ry="18" fill={C.sub} />
    </svg>
  );
}

export function KitchenArt({ className = "" }) {
  return (
    <svg viewBox="0 0 520 360" className={className} role="img" aria-label="Illustration of a modern kitchen" fill="none">
      <rect width="520" height="360" fill="#333333" />
      {/* upper cabinets */}
      <rect x="40" y="40" width="120" height="60" rx="6" fill="#4a4a4a" stroke="#5a5a5a" strokeWidth="2" />
      <rect x="170" y="40" width="120" height="60" rx="6" fill="#4a4a4a" stroke="#5a5a5a" strokeWidth="2" />
      <line x1="100" y1="46" x2="100" y2="94" stroke="#5a5a5a" strokeWidth="2" />
      <line x1="230" y1="46" x2="230" y2="94" stroke="#5a5a5a" strokeWidth="2" />
      {/* hood */}
      <path d="M330 40 h120 v20 l-20 24 h-80 l-20 -24 Z" fill={C.orange} opacity="0.85" />
      {/* backsplash */}
      <rect x="40" y="120" width="410" height="60" fill="#3E3E3E" />
      {[...Array(8)].map((_, i) => <line key={i} x1={40 + i * 52} y1="120" x2={40 + i * 52} y2="180" stroke="#484848" strokeWidth="1.5" />)}
      {/* counter */}
      <rect x="30" y="180" width="440" height="18" rx="4" fill={C.sand} />
      {/* lower cabinets */}
      <rect x="40" y="198" width="410" height="120" fill="#4a4a4a" />
      {[0, 1, 2, 3].map((i) => <rect key={i} x={52 + i * 100} y="210" width="84" height="96" rx="6" fill="#3E3E3E" stroke="#5a5a5a" strokeWidth="2" />)}
      {[0, 1, 2, 3].map((i) => <rect key={i} x={88 + i * 100} y="250" width="12" height="4" rx="2" fill={C.sand} />)}
      {/* faucet + sink */}
      <path d="M250 180 v-26 h20" stroke={C.off} strokeWidth="3" fill="none" strokeLinecap="round" />
      <rect x="240" y="184" width="46" height="10" rx="3" fill="#2a2a2a" />
      {/* bowl */}
      <circle cx="150" cy="188" r="9" fill={C.orange} />
      {/* pendant lights */}
      <line x1="180" y1="40" x2="180" y2="0" stroke="#5a5a5a" strokeWidth="2" />
      <circle cx="180" cy="44" r="7" fill={C.orange} />
    </svg>
  );
}

export function BedroomArt({ className = "" }) {
  return (
    <svg viewBox="0 0 300 260" className={className} role="img" aria-label="Illustration of a bedroom" fill="none">
      <rect width="300" height="260" fill={C.sub} />
      {/* headboard */}
      <rect x="60" y="60" width="180" height="70" rx="10" fill={C.char} />
      {/* pillows */}
      <rect x="74" y="120" width="70" height="26" rx="8" fill="#fff" stroke={C.line} strokeWidth="1.5" />
      <rect x="156" y="120" width="70" height="26" rx="8" fill="#fff" stroke={C.line} strokeWidth="1.5" />
      {/* bed */}
      <rect x="54" y="140" width="192" height="70" rx="10" fill={C.sand} />
      <rect x="54" y="176" width="192" height="34" rx="8" fill={C.orange} opacity="0.85" />
      {/* legs */}
      <rect x="60" y="210" width="10" height="20" rx="3" fill={C.char} />
      <rect x="230" y="210" width="10" height="20" rx="3" fill={C.char} />
      {/* nightstand + lamp */}
      <rect x="248" y="168" width="34" height="42" rx="4" fill={C.char} />
      <line x1="265" y1="168" x2="265" y2="150" stroke={C.char} strokeWidth="2" />
      <path d="M255 150 h20 l-4 -14 h-12 Z" fill={C.orange} />
      {/* window */}
      <rect x="24" y="40" width="30" height="120" rx="6" fill="#fff" stroke={C.line} strokeWidth="2" />
      <line x1="24" y1="100" x2="54" y2="100" stroke={C.line} strokeWidth="2" />
    </svg>
  );
}

// Small decorative blueprint grid for accents
export function BlueprintArt({ className = "" }) {
  return (
    <svg viewBox="0 0 300 260" className={className} role="img" aria-label="Floor plan illustration" fill="none">
      <rect width="300" height="260" fill={C.char} />
      <g stroke="#4d4d4d" strokeWidth="1">
        {[...Array(15)].map((_, i) => <line key={`v${i}`} x1={i * 20} y1="0" x2={i * 20} y2="260" />)}
        {[...Array(13)].map((_, i) => <line key={`h${i}`} x1="0" y1={i * 20} x2="300" y2={i * 20} />)}
      </g>
      <g stroke={C.orange} strokeWidth="2.5" fill="none">
        <rect x="40" y="40" width="220" height="180" rx="2" />
        <line x1="150" y1="40" x2="150" y2="130" />
        <line x1="40" y1="130" x2="150" y2="130" />
        <path d="M150 130 a40 40 0 0 0 40 -40" />
      </g>
      <rect x="60" y="60" width="30" height="18" rx="2" fill={C.sand} opacity="0.6" />
      <circle cx="210" cy="170" r="14" fill={C.orange} opacity="0.5" />
    </svg>
  );
}

// Distinct line-art icon per journey step (1–7).
export function JourneyIcon({ step, className = "" }) {
  const s = { stroke: C.orange, strokeWidth: 2.4, strokeLinecap: "round", strokeLinejoin: "round", fill: "none" };
  const map = {
    1: <g {...s}><path d="M8 12h24v16H20l-6 6v-6H8z" /><path d="M14 18h12M14 23h8" /></g>,
    2: <g {...s}><rect x="7" y="16" width="34" height="18" rx="6" /><circle cx="17" cy="25" r="4" /><circle cx="31" cy="25" r="4" /><path d="M21 25h6" /><path d="M14 16l3-4h14l3 4" /></g>,
    3: <g {...s}><rect x="12" y="8" width="24" height="32" rx="3" /><path d="M18 16h12M18 22h12M18 28h7" /><path d="M27 33h7" /></g>,
    4: <g {...s}><path d="M10 40V22l9 5V22l9 5V14l10 6v20z" /><path d="M10 40h28" /></g>,
    5: <g {...s}><rect x="8" y="16" width="32" height="22" rx="4" /><circle cx="24" cy="27" r="6" /><path d="M16 16l3-5h10l3 5" /></g>,
    6: <g {...s}><rect x="12" y="10" width="24" height="30" rx="3" /><rect x="19" y="7" width="10" height="6" rx="2" /><path d="M17 22l4 4 8-9" /></g>,
    7: <g {...s}><path d="M24 8l14 5v10c0 9-6 14-14 17-8-3-14-8-14-17V13z" /><path d="M18 24l4 4 8-9" /></g>,
  };
  return <svg width="40" height="40" viewBox="0 0 48 48" className={className} aria-hidden>{map[step] || map[1]}</svg>;
}

// Warm "happy home" illustration for the reviews section header.
export function HappyHomeArt({ className = "" }) {
  return (
    <svg viewBox="0 0 360 300" className={className} role="img" aria-label="A happy ILLAM home" fill="none">
      <circle cx="300" cy="66" r="34" fill={C.orange} opacity="0.2" />
      <circle cx="300" cy="66" r="19" fill={C.orange} opacity="0.45" />
      <path d="M70 152 L180 70 L290 152" stroke={C.char} strokeWidth="6" strokeLinejoin="round" fill="none" />
      <rect x="95" y="150" width="170" height="110" rx="6" fill="#fff" stroke={C.char} strokeWidth="3" />
      <rect x="160" y="200" width="40" height="60" rx="4" fill={C.orange} />
      <circle cx="192" cy="230" r="2.5" fill="#fff" />
      <rect x="115" y="175" width="34" height="30" rx="3" fill={C.sub} stroke={C.char} strokeWidth="2" />
      <rect x="211" y="175" width="34" height="30" rx="3" fill={C.sub} stroke={C.char} strokeWidth="2" />
      <path d="M132 175v30M115 190h34" stroke={C.char} strokeWidth="1.5" />
      <path d="M228 175v30M211 190h34" stroke={C.char} strokeWidth="1.5" />
      <path d="M180 101c-6-8-18-4-18 5 0 7 12 13 18 18 6-5 18-11 18-18 0-9-12-13-18-5z" fill={C.orange} />
      <rect x="290" y="230" width="26" height="30" rx="4" fill={C.sand} />
      <path d="M303 230C288 205 284 190 298 180c3 16 6 32 5 50z" fill={C.char} />
      <line x1="50" y1="260" x2="330" y2="260" stroke={C.line} strokeWidth="3" />
    </svg>
  );
}
